import type { FileExplorerIconSize } from '@/components/document/sub-components/file-manager/logic/core/useFileManagerSettings';

// Row padding (applied to both .details-header and .details-row so they stay aligned).
export const ROW_PADDING: Record<FileExplorerIconSize, string> = {
  small: '0.375rem',
  medium: '0.5rem',
  large: '0.75rem',
};

// Modified / Modified by / Size cells and pills.
export const META_FONT_SIZES: Record<FileExplorerIconSize, string> = {
  small: '0.75rem',
  medium: '0.8125rem',
  large: '0.9375rem',
};

export const HEADER_FONT_SIZES: Record<FileExplorerIconSize, string> = {
  small: '0.6875rem',
  medium: '0.75rem',
  large: '0.875rem',
};
